var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirdCoins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.45914C8.08488 2.45914 2.45898 8.08493 2.45898 15C2.45898 21.9151 8.08488 27.5411 15 27.5411C21.9152 27.5411 27.541 21.9151 27.541 15C27.541 8.08493 21.9152 2.45914 15 2.45914Z",
    fill: "#E9B522"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.45916C8.08487 2.45916 2.45897 8.08495 2.45897 15.0001C2.45897 21.9152 8.08487 27.5411 15 27.5411C21.9152 27.5411 27.541 21.9152 27.541 15.0001C27.541 8.08495 21.9152 2.45916 15 2.45916ZM15 30C6.72902 30 0 23.2711 0 15.0001C0 6.72905 6.72902 0 15 0C23.271 0 30 6.72905 30 15.0001C30 23.2711 23.271 30 15 30Z",
    fill: "#F7DE61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.914752 15.0001C0.914752 6.88177 7.39718 0.250498 15.4574 0.00751033C15.3054 0.0029965 15.1531 0 15 0C6.72902 0 0 6.72905 0 15.0001C0 23.2711 6.72902 30 15 30C15.1531 30 15.3054 29.997 15.4574 29.9925C7.39718 29.7498 0.914752 23.118 0.914752 15.0001Z",
    fill: "#FFF2BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.45914C14.866 2.45914 14.7326 2.46214 14.5996 2.46593C21.3301 2.67805 26.7402 8.2189 26.7402 15C26.7402 21.7811 21.3301 27.3218 14.5996 27.5341C14.7326 27.5382 14.866 27.5411 15 27.5411C21.9152 27.5411 27.541 21.9151 27.541 15C27.541 8.08493 21.9152 2.45914 15 2.45914Z",
    fill: "#CE9811"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1465 14.8716L16.6109 5.86819C16.6109 5.86819 13.6119 7.5776 14.4436 10.5306C15.2769 13.4893 19.1465 14.8716 19.1465 14.8716Z",
    fill: "#CE9811"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2822 6.08748C16.2908 6.08039 16.2996 6.07444 16.3084 6.06844C16.8531 7.85728 17.3911 9.78458 17.8398 11.5643C17.2958 9.81488 16.7503 7.89442 16.2822 6.08748Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8721 6.41416C15.8832 6.40403 15.8936 6.39527 15.9039 6.38654C16.4288 8.12145 16.9443 9.97686 17.3789 11.694C16.8539 10.0082 16.3275 8.16397 15.8721 6.41416Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4756 6.79557C15.4891 6.78127 15.5018 6.76838 15.5142 6.75438C16.0149 8.42021 16.5027 10.1854 16.9175 11.8241C16.4185 10.2184 15.9165 8.46895 15.4756 6.79557Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6382 18.6142L6.71517 21.4117L7.39372 19.9304L5.37305 18.6102L12.215 16.7779L12.6382 18.6142Z",
    fill: "#CE9811"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2154 16.7777L11.5879 16.9454L12.306 18.768L12.6385 18.6145L12.2154 16.7777Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5775 18.3518C11.2606 18.9704 9.91976 19.5381 8.55859 20.0522C9.87542 19.4333 11.2165 18.8663 12.5775 18.3518Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2728 17.0285C10.8429 17.5156 9.39502 17.9496 7.93262 18.328C9.3624 17.8405 10.8105 17.4074 12.2728 17.0285Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4281 17.7015C11.0346 18.2518 9.62056 18.7498 8.18945 19.1931C9.58278 18.6424 10.9971 18.1452 12.4281 17.7015Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3485 17.3564C10.9259 17.8881 9.4837 18.3673 8.02539 18.7914C9.44785 18.2592 10.8903 17.7809 12.3485 17.3564Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5036 18.0294C11.1281 18.6257 9.73021 19.1705 8.31348 19.6611C9.6889 19.0644 11.0871 18.5204 12.5036 18.0294Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.856 15.8292C21.856 15.8292 23.1523 14.4347 21.9853 12.8559C20.8184 11.2771 18.7746 12.0398 18.7746 12.0398C18.7746 12.0398 14.4368 11.2932 12.6026 14.212C11.0076 16.75 12.2944 19.055 14.4029 20.1277C16.4897 21.1894 18.4804 21.2226 19.8886 19.361C21.2968 17.4994 21.856 15.8292 21.856 15.8292Z",
    fill: "#CE9811"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.424 18.6057C19.6163 19.0659 18.5688 19.1354 17.7408 18.7608C16.2386 18.081 15.0152 16.4098 16.0741 14.5169C17.1156 12.6555 18.7735 12.0405 18.7735 12.0405L18.774 12.0395C18.774 12.0395 18.7756 12.039 18.7785 12.0381C18.7811 12.0381 18.7846 12.0361 18.7892 12.0346L18.8073 12.0287C18.8143 12.0272 18.8224 12.0238 18.8315 12.0208C18.8405 12.0179 18.8511 12.0145 18.8617 12.011C19.2665 11.8867 20.9622 11.4725 21.9856 12.8554C22.123 13.0412 22.2252 13.2243 22.3009 13.4027C22.3261 13.4622 22.3477 13.5211 22.367 13.58C22.3955 13.6677 22.4175 13.7533 22.4345 13.8388C22.4451 13.8946 22.4533 13.9505 22.4604 14.0058C22.4712 14.1159 22.4745 14.2235 22.4707 14.3274C22.4684 14.3792 22.464 14.4299 22.4591 14.4791C22.4555 14.5037 22.4523 14.5298 22.4486 14.5544C22.3964 14.8997 22.2693 15.1943 22.1461 15.414C22.0719 15.5451 21.9998 15.6496 21.945 15.7201C21.9445 15.7211 21.9445 15.7211 21.944 15.7221C21.9288 15.7421 21.9151 15.7591 21.9039 15.7736C21.8842 15.7976 21.87 15.8131 21.8629 15.822C21.8609 15.8235 21.8598 15.8255 21.8593 15.8266C21.8563 15.8275 21.8558 15.8285 21.8558 15.8285C21.8558 15.8285 21.8553 15.8295 21.8558 15.831C21.8558 15.831 21.8558 15.831 21.8563 15.8325C21.8291 15.9082 21.4087 17.1187 20.424 18.6057Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3919 13.8497C17.9894 14.6408 18.3043 15.6077 19.0954 16.0102C19.4738 16.2027 19.9671 16.2146 20.3499 16.1237C20.742 16.0306 21.8562 15.829 21.8562 15.829C21.8562 15.829 22.5239 15.1111 22.469 14.1214L20.5524 13.1463C19.7613 12.7438 18.7939 13.0596 18.3919 13.8497Z",
    fill: "white",
    fillOpacity: 0.501961
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2667 14.2588C20.1452 14.4977 20.2403 14.7899 20.4792 14.9114C20.7181 15.0329 21.0103 14.9378 21.1318 14.6989C21.2534 14.46 21.1582 14.1678 20.9193 14.0463C20.6804 13.9247 20.3883 14.0199 20.2667 14.2588Z",
    fill: "#CE9811"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4814 14.9995L22.3641 14.914L23.3213 15.9355L21.4814 14.9995Z",
    fill: "#CE9811"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4814 14.9995L22.6209 15.5792L22.0807 15.5244L21.4814 14.9995Z",
    fill: "#CE9811",
    stroke: "#CE9811",
    strokeWidth: 0.0762,
    strokeMiterlimit: 22.9256
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17.53 13.6227L11.4112 6.54782C11.4112 6.54782 9.42186 9.36893 11.4287 11.6894C13.4395 14.0143 17.53 13.6227 17.53 13.6227Z",
    fill: "#CE9811"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.53 13.6227L11.4112 6.54782C11.4112 6.54782 9.42186 9.36893 11.4287 11.6894C13.4395 14.0143 17.53 13.6227 17.53 13.6227Z",
    fill: "#CE9811",
    fillOpacity: 0.101961
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2061 6.88593C11.2108 6.87596 11.2162 6.86678 11.2216 6.8576C12.4744 8.24592 13.7799 9.7623 14.9418 11.1831C13.7064 9.83028 12.3971 8.32319 11.2061 6.88593Z",
    fill: "#CE9811",
    fillOpacity: 0.101961
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9736 7.35583C10.9794 7.34187 10.9851 7.32954 10.9907 7.31721C12.2026 8.66514 13.4572 10.126 14.5798 11.4962C13.3886 10.1928 12.129 8.74662 10.9736 7.35583Z",
    fill: "#CE9811",
    fillOpacity: 0.101961
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7764 7.8696C10.7825 7.8509 10.7885 7.83383 10.7938 7.81593C11.9544 9.11151 13.1456 10.5025 14.217 11.81C13.0835 10.5681 11.8861 9.19735 10.7764 7.8696Z",
    fill: "#CE9811",
    fillOpacity: 0.101961
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3837 19.4004C17.8312 19.3207 17.768 19.7597 17.6629 19.9297C17.5432 20.123 17.3483 20.1897 17.2012 20.1848",
    stroke: "#CE9811",
    strokeWidth: 0.7056,
    strokeMiterlimit: 22.9256
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0556 19.3512C17.5032 19.2716 17.4399 19.7106 17.3347 19.8805C17.2151 20.0738 17.0202 20.1405 16.873 20.1356",
    stroke: "#CE9811",
    strokeWidth: 0.7056,
    strokeMiterlimit: 22.9256
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7285 19.3019C17.176 19.2223 17.1127 19.6613 17.0076 19.8312C16.888 20.0245 16.6931 20.0912 16.5459 20.0863",
    stroke: "#CE9811",
    strokeWidth: 0.7056,
    strokeMiterlimit: 22.9256
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0273 19.8422C19.4748 19.7625 19.4115 20.2015 19.3064 20.3714C19.1868 20.5647 18.9919 20.6315 18.8447 20.6266",
    stroke: "#CE9811",
    strokeWidth: 0.7056,
    strokeMiterlimit: 22.9256
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6991 19.793C19.1467 19.7133 19.0834 20.1523 18.9783 20.3222C18.8587 20.5156 18.6638 20.5823 18.5166 20.5774",
    stroke: "#CE9811",
    strokeWidth: 0.7056,
    strokeMiterlimit: 22.9256
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M18.372 19.7437C18.8196 19.6641 18.7562 20.103 18.6511 20.273C18.5315 20.4663 18.3366 20.533 18.1895 20.5281",
    stroke: "#CE9811",
    strokeWidth: 0.7056,
    strokeMiterlimit: 22.9256
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 14.8051L16.2827 5.74852C16.2827 5.74852 13.2661 7.46802 14.1027 10.4384C14.9408 13.4146 18.8333 14.8051 18.8333 14.8051Z",
    fill: "#F7DE61"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9521 5.96907C15.9608 5.96197 15.9696 5.95594 15.9785 5.94991C16.5264 7.7493 17.0676 9.68797 17.519 11.4782C16.9717 9.71847 16.423 7.78666 15.9521 5.96907Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M15.54 6.29767C15.5512 6.28751 15.5617 6.27867 15.5721 6.26987C16.1 8.01505 16.6186 9.88138 17.0557 11.6087C16.5277 9.91291 15.9982 8.0578 15.54 6.29767Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1406 6.68134C15.1542 6.66693 15.1669 6.65396 15.1794 6.63988C15.6831 8.31554 16.1738 10.0911 16.591 11.7395C16.0891 10.1243 15.5842 8.36455 15.1406 6.68134Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2865 18.5696L6.32853 21.3836L7.0111 19.8936L4.97852 18.5656L11.8608 16.7225L12.2865 18.5696Z",
    fill: "#F7DE61"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8607 16.7223L11.2295 16.891L11.9518 18.7244L12.2863 18.57L11.8607 16.7223Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2253 18.3057C10.9005 18.9279 9.55182 19.499 8.18262 20.0161C9.50722 19.3935 10.8562 18.8232 12.2253 18.3057Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9186 16.9746C10.4802 17.4646 9.02375 17.9011 7.55273 18.2818C8.99094 17.7914 10.4476 17.3557 11.9186 16.9746Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0742 17.6515C10.6725 18.2051 9.25012 18.7061 7.81055 19.152C9.21211 18.598 10.6348 18.0979 12.0742 17.6515Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9941 17.3044C10.5631 17.8393 9.11243 18.3213 7.64551 18.7479C9.07635 18.2126 10.5273 17.7314 11.9941 17.3044Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1504 17.9814C10.7667 18.5812 9.36063 19.1292 7.93555 19.6228C9.31905 19.0225 10.7255 18.4753 12.1504 17.9814Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5593 15.7683C21.5593 15.7683 22.8632 14.3656 21.6894 12.7774C20.5156 11.1894 18.4597 11.9566 18.4597 11.9566C18.4597 11.9566 14.0964 11.2055 12.2513 14.1415C10.6469 16.6945 11.9413 19.0131 14.0622 20.0921C16.1613 21.1601 18.1638 21.1934 19.5803 19.3209C20.9968 17.4483 21.5593 15.7683 21.5593 15.7683Z",
    fill: "#F7DE61"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M20.118 18.5611C19.3056 19.024 18.2518 19.0939 17.419 18.7171C15.908 18.0334 14.6774 16.3523 15.7424 14.4483C16.7901 12.5759 18.4578 11.9572 18.4578 11.9572L18.4583 11.9563C18.4583 11.9563 18.4598 11.9557 18.4629 11.9547C18.4654 11.9548 18.4689 11.9528 18.4735 11.9513L18.4918 11.9454C18.4988 11.9439 18.5069 11.9404 18.516 11.9374C18.5252 11.9345 18.5358 11.931 18.5464 11.9275C18.9537 11.8025 20.6594 11.3858 21.6889 12.7769C21.827 12.9638 21.9299 13.148 22.0059 13.3275C22.0313 13.3873 22.0531 13.4466 22.0724 13.5058C22.1011 13.594 22.1233 13.6801 22.1404 13.7661C22.151 13.8223 22.1593 13.8785 22.1664 13.9341C22.1773 14.0448 22.1806 14.1531 22.1768 14.2576C22.1745 14.3097 22.1701 14.3607 22.1652 14.4102C22.1614 14.4349 22.1583 14.4612 22.1545 14.4859C22.1021 14.8333 21.9741 15.1296 21.8503 15.3506C21.7756 15.4825 21.7031 15.5876 21.648 15.6585C21.6475 15.6595 21.6475 15.6595 21.647 15.6605C21.6317 15.6806 21.6179 15.6977 21.6067 15.7123C21.5868 15.7364 21.5726 15.752 21.5654 15.761C21.5633 15.7626 21.5623 15.7646 21.5618 15.7656C21.5588 15.7665 21.5583 15.7676 21.5583 15.7676C21.5583 15.7676 21.5577 15.7685 21.5583 15.7701C21.5583 15.7701 21.5583 15.7701 21.5587 15.7716C21.5314 15.8477 21.1085 17.0654 20.118 18.5611Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0746 13.7771C17.6697 14.5728 17.9864 15.5455 18.7822 15.9503C19.1629 16.144 19.6591 16.1559 20.0441 16.0645C20.4385 15.9709 21.5592 15.768 21.5592 15.768C21.5592 15.768 22.2309 15.0459 22.1757 14.0504L20.2478 13.0695C19.452 12.6646 18.4789 12.9823 18.0746 13.7771Z",
    fill: "white",
    fillOpacity: 0.501961
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9604 14.1886C19.8382 14.4289 19.9338 14.7228 20.1741 14.845C20.4144 14.9673 20.7083 14.8716 20.8305 14.6313C20.9527 14.391 20.8571 14.0971 20.6168 13.9748C20.3765 13.8526 20.0827 13.9483 19.9604 14.1886Z",
    fill: "#CE9811"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1826 14.9337L22.0705 14.8477L23.0332 15.8752L21.1826 14.9337Z",
    fill: "#CE9811"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1826 14.9337L22.3287 15.5168L21.7854 15.4618L21.1826 14.9337Z",
    fill: "#CE9811"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M17.207 13.5487L11.0521 6.43217C11.0521 6.43217 9.05105 9.26989 11.0698 11.604C13.0924 13.9426 17.207 13.5487 17.207 13.5487Z",
    fill: "#F7DE61"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M17.207 13.5487L11.0521 6.43217C11.0521 6.43217 9.05105 9.26989 11.0698 11.604C13.0924 13.9426 17.207 13.5487 17.207 13.5487Z",
    fill: "#F7DE61",
    fillOpacity: 0.101961
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8467 6.77234C10.8514 6.76229 10.8569 6.75308 10.8624 6.74382C12.1225 8.14034 13.4358 9.66567 14.6045 11.0948C13.3619 9.73402 12.0448 8.21806 10.8467 6.77234Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6123 7.24495C10.6181 7.23092 10.6238 7.21851 10.6295 7.20615C11.8485 8.562 13.1105 10.0315 14.2397 11.4097C13.0415 10.0986 11.7744 8.64393 10.6123 7.24495Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4141 7.76177C10.4202 7.74299 10.4262 7.72581 10.4316 7.70779C11.5991 9.011 12.7973 10.4102 13.875 11.7254C12.7348 10.4762 11.5303 9.09737 10.4141 7.76177Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0596 19.3606C17.5098 19.2804 17.4462 19.722 17.3404 19.8929C17.2201 20.0874 17.024 20.1545 16.876 20.1496",
    stroke: "#CE9811",
    strokeWidth: 0.7056,
    strokeMiterlimit: 22.9256
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7295 19.311C17.1797 19.2308 17.116 19.6724 17.0103 19.8433C16.89 20.0378 16.6939 20.1049 16.5459 20.1",
    stroke: "#CE9811",
    strokeWidth: 0.7056,
    strokeMiterlimit: 22.9256
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4005 19.2615C16.8506 19.1814 16.787 19.6229 16.6812 19.7938C16.5609 19.9883 16.3649 20.0554 16.2168 20.0505",
    stroke: "#CE9811",
    strokeWidth: 0.7056,
    strokeMiterlimit: 22.9256
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7129 19.805C19.1631 19.7248 19.0994 20.1664 18.9937 20.3373C18.8734 20.5318 18.6773 20.5989 18.5293 20.594",
    stroke: "#CE9811",
    strokeWidth: 0.7056,
    strokeMiterlimit: 22.9256
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3828 19.7554C18.833 19.6752 18.7694 20.1168 18.6636 20.2878C18.5433 20.4822 18.3472 20.5493 18.1992 20.5444",
    stroke: "#CE9811",
    strokeWidth: 0.7056,
    strokeMiterlimit: 22.9256
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0537 19.7059C18.5039 19.6258 18.4402 20.0673 18.3345 20.2382C18.2142 20.4327 18.0182 20.4998 17.8701 20.4949",
    stroke: "#CE9811",
    strokeWidth: 0.7056,
    strokeMiterlimit: 22.9256
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirdCoins);
export default __webpack_public_path__ + "static/media/bird_coins.c2434b1ef0d2dff510c4f5015581e654.svg";
export { ForwardRef as ReactComponent };